import { FormlyModule, FormlyFieldConfig } from '@ngx-formly/core';
import { QuestionWrapperComponent } from '../components/question-wrapper/question-wrapper.component';
import { InputWithAddonComponent } from '../components/input-with-addon/input-with-addon.component';

import { Validators,FormControl, ControlValueAccessor,  ValidationErrors } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { StaticTextComponent } from '../components/static-text/static-text.component';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { DatePickerComponent } from '../components/date-picker/date-picker.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { MulticheckboxComponent } from './multicheckbox/multicheckbox.component';
import { TaskComponent } from '../components/task/task.component';
import {FileCheckboxComponent} from '../components/file-checkbox/file-checkbox.component';

import * as _ from 'lodash';
import { FormlyTemplateOptions } from '@ngx-formly/core/src/components/formly.field.config';


export const fileUploadConfigs = {
    'allowedMimeType': ["application/msword","application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/rtf", "text/plain", "image/png", "image/jpeg", "image/jpeg", "image/gif", "image/tiff", "image/bmp", "application/pdf", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-outlook"],
    'allowedFileType': [],
    'maxFileSize': 0,
    'queueLimit': 0,
    'multiple': false
};

// for AoT
export function patternErrorMessage(err, field) {
    let text = field.key;
    if (_.has(field.templateOptions, 'originalLabel') && field.templateOptions['originalLabel'] !== '') {
        text = field.templateOptions.originalLabel;
    }
    // console.log(`${text} error. Actual val:` + JSON.stringify(err.actualValue) + ` vs Required val: ` + JSON.stringify(err.requiredPattern) );

    // return `${text} must follow the pattern: ${err.requiredPattern}`;
    return `<i>${text}</i> is invalid`;
}

export function requiredErrorMessage(err, field) {
    let text = field.key;
    if (_.has(field.templateOptions, 'originalLabel') && field.templateOptions['originalLabel'] !== '') {
        text = field.templateOptions.originalLabel;
    }
    return `<i>${text}</i> is required.`;
}

export function emailErrorMessage(err, field) {
    let text = field.key;
    if (_.has(field.templateOptions, 'originalLabel') && field.templateOptions['originalLabel'] !== '') {
        text = field.templateOptions.originalLabel;
    }

    return `<i>${text}</i> must be a valid email address`;
}


// define custom validation error message
/*export function CustomValidation_WrongAnswersMessage(err, field) {
  return `<i class="fa fa-times text-danger fa-3x" aria-hidden="true"></i>`;
  //return `incorrect`;
}*/

// define custom validation method
/*export function CustomValidation_WrongAnswers(control: FormControl, field: FormlyFieldConfig): ValidationErrors {

  if (_.has(field.templateOptions, 'correctanswers')) {

    let selectedAnsArr = control.value;
    let correctAnsArr = field.templateOptions.correctanswers.split(',');

    selectedAnsArr = selectedAnsArr.sort();// sort array in order
    correctAnsArr = correctAnsArr.sort(); // sort array in order

    //console.log(selectedAnsArr);// selected value in array
    //console.log(correctAnsArr); // correct value in , seperated string

    let same = (selectedAnsArr.length === correctAnsArr.length && selectedAnsArr.every(function (value, index) { return value === correctAnsArr[index] }));

    //console.log(same);
    return  same ?  null : { 'wronganswers': false };

  }
}*/


export const configs = {
    types: [
        {
            name: 'input-addon',
            component: InputWithAddonComponent,
            defaultOptions: {
                templateOptions: {
                    addonLeft: null,
                    addOnRight: null
                }
            },
            wrappers: ['fieldset', 'label'],
            extends: 'input'
        },
        {
            name: 'statictext',
            component: StaticTextComponent
        },
        {
            name: 'task',
            component: TaskComponent
        },
        {
            name: 'file-checkbox',
            component: FileCheckboxComponent,
            defaultOptions: {
                templateOptions: {
                    href: null,
                    fid: null,
                    label: null
                }
            },
        },
        {
            name: 'file',
            component: FileUploadComponent,
            defaultOptions: {
                templateOptions: {
                    fileOptions: Object.assign({}, fileUploadConfigs, { multiple: false })
                }
            }
        },
        {
            name: 'files',
            component: FileUploadComponent,
            defaultOptions: {
                templateOptions: {
                    fileOptions: Object.assign({}, fileUploadConfigs, { multiple: true })
                }
            }
        },
        {
            name: 'datepicker', component: DatePickerComponent, extends: 'input', wrappers: ['fieldset', 'label']
        },
        {
            name: 'multiselect', component: MultiselectComponent, wrappers: ['fieldset', 'label']
        }
        ,
        {
            // custom multi-checkbox component: multicheckbox.component.ts, we don't need wrappers
          name: 'multicheckbox', component: MulticheckboxComponent
        }
    ],
    validators: [
        { name: 'required', validation: Validators.required},
        { name: 'email', validation: CustomValidators.email },
        // register custom validation name and method
        //{ name: 'wronganswers', validation: CustomValidation_WrongAnswers },

    ],
    validationMessages: [
        { name: 'required', message: requiredErrorMessage
        },
        {
            name: 'email', message: emailErrorMessage
        },
        {
            name: 'pattern', message: patternErrorMessage
        },
        //{
        //    name: 'wronganswers', message: CustomValidation_WrongAnswersMessage
        //}
    ],
    wrappers: [
        { name: 'questionWrapper', component: QuestionWrapperComponent }
    ]
};
export const formlyConfigs = FormlyModule.forRoot(configs);






// WEBPACK FOOTER //
// ./src/app/stage/containers/formlyConfigs.ts